"use client";

import Image from "next/image";
import type { JSX } from "react";
import type { ChatScenarioAvatar } from "./types";

interface MessageAvatarProps {
  avatar: ChatScenarioAvatar;
}

export function MessageAvatar({ avatar }: MessageAvatarProps): JSX.Element {
  return (
    <div className='tw-size-6 tw-shrink-0 tw-overflow-hidden tw-rounded-full'>
      <Image alt={avatar.alt ?? ""} className='tw-size-full tw-object-cover' height={24} src={avatar.url} width={24} />
    </div>
  );
}
